import { addToListActions } from "../constants.js";
function focusIntoRef(ref) {
  if (ref == null ? void 0 : ref.current) {
    ref.current.focus();
  }
}
const fetchWishList = async (args) => {
  const {
    dispatch,
    enableModernApis,
    siteValue,
    state,
    msStore,
    agent,
    getToken
  } = args;
  const { drawerContent } = state;
  const createNewListTitle = msStore.getKeyValueItem("createnewlisttitle");
  try {
    const authCookie = await getToken();
    if (!enableModernApis) {
      agent == null ? void 0 : agent.getWishListsLegacy().then((res) => {
        const wishLists = res == null ? void 0 : res.shoppinglist.map((list) => ({
          text: list.description,
          value: list.listId
        }));
        if (!wishLists.length) {
          dispatch({
            payload: {
              drawerContent: [
                ...drawerContent,
                {
                  bodyContent: "createNewList",
                  hasStickyBar: false,
                  title: createNewListTitle
                }
              ],
              clientIdLegacy: res.clientId,
              isLoading: false,
              wishListFetched: true,
              wishLists: wishLists || []
            },
            type: addToListActions.UPDATE_STATE
          });
        } else {
          dispatch({
            payload: {
              drawerContent: drawerContent.filter(
                (drawer) => drawer.bodyContent !== "createNewList"
              ),
              clientIdLegacy: res.clientId,
              isLoading: false,
              wishListFetched: true,
              wishLists
            },
            type: addToListActions.UPDATE_STATE
          });
        }
      }).catch((err) => {
        console.error(`get Lists Api failure with error: ${err}`);
        dispatch({
          payload: {
            errorMsg: msStore.getKeyValueItem(
              "getlistapierrormessage"
            ),
            isLoading: false,
            showError: true
          },
          type: addToListActions.SHOW_ERROR
        });
      });
    } else if (authCookie) {
      agent == null ? void 0 : agent.fetchWishLists(authCookie, siteValue).then((res) => {
        if ((res == null ? void 0 : res.message) === "Lists do not exist") {
          dispatch({
            payload: {
              isLoading: false,
              wishLists: []
            },
            type: addToListActions.UPDATE_STATE
          });
          return;
        }
        const wishLists = res == null ? void 0 : res.map(
          (wishListItem) => ({
            text: wishListItem.title,
            value: wishListItem.id
          })
        );
        if (!wishLists.length) {
          dispatch({
            payload: {
              drawerContent: [
                ...drawerContent,
                {
                  bodyContent: "createNewList",
                  hasStickyBar: false,
                  title: createNewListTitle
                }
              ],
              isLoading: false,
              wishListFetched: true,
              wishLists: wishLists || []
            },
            type: addToListActions.UPDATE_STATE
          });
        } else {
          dispatch({
            payload: {
              drawerContent: drawerContent.filter(
                (drawer) => drawer.bodyContent !== "createNewList"
              ),
              isLoading: false,
              wishListFetched: true,
              wishLists
            },
            type: addToListActions.UPDATE_STATE
          });
        }
      }).catch((err) => {
        console.error(`get Lists Api failure with error: ${err}`);
        dispatch({
          payload: {
            errorMsg: msStore.getKeyValueItem(
              "getlistapierrormessage"
            ),
            isLoading: false,
            showError: true
          },
          type: addToListActions.SHOW_ERROR
        });
      });
    }
  } catch {
    console.error("Token fetch failed");
    dispatch({
      payload: {
        isLoading: false,
        wishLists: []
      },
      type: addToListActions.UPDATE_STATE
    });
  }
};
export {
  fetchWishList,
  focusIntoRef
};
